import React from 'react'
import { IInvoiceProfile, ITransactions } from 'src/types/types';
import service from '../services/api'
const useTransactions = () => {
  
    const [transactions, setTransactions] = React.useState<ITransactions[]>([]);
    const [loading, setLoading] = React.useState<boolean>(false);
    const [error, setError] = React.useState<string | null>(null);
    const [selectedProfileId, setSelectedProfileId] = React.useState<number | null>(null);

    const fetchTransactions = async (invoiceProfileId:number) => {
        setLoading(true);
        setError(null);

        try {
            const response = await service.get('/transactions/'+invoiceProfileId);
            setTransactions(response.data);
        } catch (err: any) {
            setError(err.message || 'Failed to fetch invoice profiles');
        }
        setLoading(false);
    };


    return {
        loading,
        error,
        selectedProfileId,
        setSelectedProfileId,
        fetchTransactions,
        transactions
    };
        



}

export default useTransactions